import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { TableHead, TableRow } from '../../Common/Table';
import { AuthContextValue, sort_order, ListParams } from '../../Common/types';
import { Grid, Table, TableBody, TableCell } from '@mui/material';
import { RotateLoader } from 'react-spinners';

import { FutureInterface } from './types';
import { useNotify } from '../../Common/snackbarHooks';
import { isEmpty } from '../../Common/utilities';
import EmptyList from '../../Common/Table/EmptyList';
import { css, commonStyles } from '../../Common/styling';
import { CreateFab } from '../../Common/ButtonLinks';
import { getFutures } from './FutureAPI';
import AuthContext from '../../Common/AuthContext';

export const filterSortDefaults = {
  query: '',
  sort_by: 'ranking',
  sort_order: sort_order.asc,
  is_active: true,
};

const Future: React.FC = () => {
  // hooks
  const rows = [
    { id: 'title', label: 'Titel', notSortable: true },
    { id: 'content', label: 'Text', notSortable: true },
    { id: 'ranking', numeric: true, label: 'Prioritering', notSortable: true },
    { id: 'empty1', label: '', notSortable: true },
    { id: 'show', label: 'Visa', notSortable: true },
    { id: 'empty2', label: '', notSortable: true },
  ];

  const navigate = useNavigate();
  const { notifyError } = useNotify();
  const [futures, setFutures] = useState<Array<FutureInterface>>([]);
  const [listParams, setGetListParams] = useState(filterSortDefaults as ListParams);
  const [loading, setLoading] = useState(true);
  const { hasPermissions } = useContext(AuthContext) as AuthContextValue;

  useEffect(() => {
    const fetchFutures = (): void => {
      setLoading(true);
      getFutures()
        .then((data) => {
          setFutures(data.data.futures);
        })
        .catch(() => notifyError('Det gick inte att hämta listan över Framtid'))
        .finally(() => setLoading(false));
    };
    fetchFutures();
  }, [listParams]); // eslint-disable-line react-hooks/exhaustive-deps

  // render
  return (
    <div>
      <Grid container className={css(commonStyles.headlineWrapper, commonStyles.greyRow)}>
        <Grid item xs={10} sm={10} md={10} lg={10}>
          <h1 className={css(commonStyles.headerTextStyle)}>Din framtid</h1>
        </Grid>
      </Grid>

      <Table classes={{ root: css(commonStyles.tableWrapper) }}>
        <TableHead rows={rows} listParams={listParams} setGetListParams={setGetListParams} />

        <TableBody>
          {isEmpty(futures) ? (
            <EmptyList />
          ) : (
            futures.map((row: FutureInterface, idx: number) => (
              <TableRow
                row={row}
                idx={idx}
                key={idx}
                onClick={(): void =>
                  hasPermissions(['admin', 'operational_leader']) ? navigate(`/future/${row.id}`) : navigate(`/future`)
                }
              >
                <TableCell scope="row" width="500">
                  <b>{row.title}</b>
                </TableCell>
                <TableCell align="left">{row.content}</TableCell>
                <TableCell align="right">{row.ranking}</TableCell>
                <TableCell align="left"></TableCell>
                <TableCell align="left">{row.show ? 'ja' : 'nej'}</TableCell>
                <TableCell align="left"></TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>

      {hasPermissions(['admin', 'operational_leader']) && <CreateFab link="create" />}
      {loading && (
        <div className={css(commonStyles.spinner)}>
          <RotateLoader loading={loading} />
        </div>
      )}
    </div>
  );
};

export default Future;
